module.exports = __webpack_public_path__ + "static/images/three.3SEjhA4.svg";